(function () {
  const MENU_SELECTOR = '#wdt-mobile-menu';
  const TOGGLE_AREA_PX = 70; // ناحیه سمت راست برای + (اگر لازم شد 90 کن)

  function getTapX(e) {
    if (e.touches && e.touches.length) return e.touches[0].clientX;
    return e.clientX;
  }

  function hasRealSubmenu(li) {
    if (!li) return false;
    const ul = li.querySelector(':scope > ul.child-menu, :scope > ul');
    return !!(ul && ul.querySelector('li'));
  }

  function isRightToggleArea(a, e) {
    if (!a) return false;
    const rect = a.getBoundingClientRect();
    const x = getTapX(e);
    return x > (rect.right - TOGGLE_AREA_PX);
  }

  function handler(e) {
    const a = e.target.closest(`${MENU_SELECTOR} a`);
    if (!a) return;

    const li = a.closest('li');
    if (!li) return;

    // اگر این آیتم زیرمنو دارد، اصلاً دخالت نکنیم تا تم خودش باز کند
    if (hasRealSubmenu(li)) return;

    // اگر کاربر سمت راست (ناحیه +) زد، دخالت نکن (برای اینکه toggle خراب نشه)
    if (isRightToggleArea(a, e)) return;

    // آیتم زیرمنو ندارد ولی کلیک کار نمی‌کند → زورکی برو
    const href = a.getAttribute('href');
    if (!href || href === '#') return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    window.location.assign(a.href);
  }

  // capture=true تا قبل از اسکریپت تم اجرا شود
  document.addEventListener('touchstart', handler, { capture: true, passive: false });
  document.addEventListener('click', handler, true);
})();
